import * as React from "react"


interface Props {
  className?: string,
  centerX: string,
  centerY: string,
  signRadius: string,
  signBorderRadius: string,
  planetRadius: string,
  houseRadius: string,
  centerRadius: string,
  DegreeSym: string,
  AriBSignX: string,
  AriBSignY: string,
  TauBSignX: string,
  TauBSignY: string,
  GemBSignX: string,
  GemBSignY: string,
  CanBSignX: string,
  CanBSignY: string,
  LeoBSignX: string,
  LeoBSignY: string,
  VirBSignX: string,
  VirBSignY: string,
  LibBSignX: string,
  LibBSignY: string,
  ScoBSignX: string,
  ScoBSignY: string,
  SagBSignX: string,
  SagBSignY: string,
  CapBSignX: string,
  CapBSignY: string,
  AquBSignX: string,
  AquBSignY: string,
  PisBSignX: string,
  PisBSignY: string,
  RXBSym: string,
  MoBPlanetX: string,
  MoBPlanetY: string,
  MoBSym:string,
  MoBSign: string,
  MoBSignSym: string,
  MoBSignX: string,
  MoBSignY: string,
  MoBDegree: string,
  MoBDegreeX: string,
  MoBDegreeY: string,
  MoBMinute: string,
  MoBMinuteX: string,
  MoBMinuteY: string,
  VeBSym:string,
  VeBPlanetX: string,
  VeBPlanetY: string,
  VeBSign: string,
  VeBSignSym: string,
  VeBSignX: string,
  VeBSignY: string,
  VeBDegree: string,
  VeBDegreeX: string,
  VeBDegreeY: string,
  VeBMinute: string,
  VeBMinuteX: string,
  VeBMinuteY: string,
  VeBRX: boolean,
  VeBRXX: string,
  VeBRXY: string,
  ASCBSym:string,
  ASCBPlanetX: string,
  ASCBPlanetY: string,
  ASCBSign: string,
  ASCBSignSym: string,
  ASCBSignX: string,
  ASCBSignY: string,
  ASCBDegree: string,
  ASCBDegreeX: string,
  ASCBDegreeY: string,
  ASCBMinute: string,
  ASCBMinuteX: string,
  ASCBMinuteY: string,
  RaBSym:string,
  RaBPlanetX: string,
  RaBPlanetY: string,
  RaBSign: string,
  RaBSignSym: string,
  RaBSignX: string,
  RaBSignY: string,
  RaBDegree: string,
  RaBDegreeX: string,
  RaBDegreeY: string,
  RaBMinute: string,
  RaBMinuteX: string,
  RaBMinuteY: string,
  RaBRX: boolean,
  RaBRXX: string,
  RaBRXY: string,
  SuBSym:string,
  SuBPlanetX: string,
  SuBPlanetY: string,
  SuBSign: string,
  SuBSignSym: string,
  SuBSignX: string,
  SuBSignY: string,
  SuBDegree: string,
  SuBDegreeX: string,
  SuBDegreeY: string,
  SuBMinute: string,
  SuBMinuteX: string,
  SuBMinuteY: string,
  ChBSym:string,
  ChBPlanetX: string,
  ChBPlanetY: string,
  ChBSign: string,
  ChBSignSym: string,
  ChBSignX: string,
  ChBSignY: string,
  ChBDegree: string,
  ChBDegreeX: string,
  ChBDegreeY: string,
  ChBMinute: string,
  ChBMinuteX: string,
  ChBMinuteY: string,
  ChBRX: boolean,
  ChBRXX: string,
  ChBRXY: string,
  MeBSym:string,
  MeBPlanetX: string,
  MeBPlanetY: string,
  MeBSign: string,
  MeBSignSym: string,
  MeBSignX: string,
  MeBSignY: string,
  MeBDegree: string,
  MeBDegreeX: string,
  MeBDegreeY: string,
  MeBMinute: string,
  MeBMinuteX: string,
  MeBMinuteY: string,
  MeBRX: boolean,
  MeBRXX: string,
  MeBRXY: string,
  JuBSym:string,
  JuBPlanetX: string,
  JuBPlanetY: string,
  JuBSign: string,
  JuBSignSym: string,
  JuBSignX: string,
  JuBSignY: string,
  JuBDegree: string,
  JuBDegreeX: string,
  JuBDegreeY: string,
  JuBMinute: string,
  JuBMinuteX: string,
  JuBMinuteY: string,
  JuBRX: boolean,
  JuBRXX: string,
  JuBRXY: string,
  UrBSym:string,
  UrBPlanetX: string,
  UrBPlanetY: string,
  UrBSign: string,
  UrBSignSym: string,
  UrBSignX: string,
  UrBSignY: string,
  UrBDegree: string,
  UrBDegreeX: string,
  UrBDegreeY: string,
  UrBMinute: string,
  UrBMinuteX: string,
  UrBMinuteY: string,
  UrBRX: boolean,
  UrBRXX: string,
  UrBRXY: string,
  ICBSym:string,
  ICBPlanetX: string,
  ICBPlanetY: string,
  ICBSign: string,
  ICBSignSym: string,
  ICBSignX: string,
  ICBSignY: string,
  ICBDegree: string,
  ICBDegreeX: string,
  ICBDegreeY: string,
  ICBMinute: string,
  ICBMinuteX: string,
  ICBMinuteY: string,
  DSCBSym:string,
  DSCBPlanetX: string,
  DSCBPlanetY: string,
  DSCBSign: string,
  DSCBSignSym: string,
  DSCBSignX: string,
  DSCBSignY: string,
  DSCBDegree: string,
  DSCBDegreeX: string,
  DSCBDegreeY: string,
  DSCBMinute: string,
  DSCBMinuteX: string,
  DSCBMinuteY: string,
  KeBSym:string,
  KeBPlanetX: string,
  KeBPlanetY: string,
  KeBSign: string,
  KeBSignSym: string,
  KeBSignX: string,
  KeBSignY: string,
  KeBDegree: string,
  KeBDegreeX: string,
  KeBDegreeY: string,
  KeBMinute: string,
  KeBMinuteX: string,
  KeBMinuteY: string,
  KeBRX: boolean,
  KeBRXX: string,
  KeBRXY: string,
  MCBSym:string,
  MCBPlanetX: string,
  MCBPlanetY: string,
  MCBSign: string,
  MCBSignSym: string,
  MCBSignX: string,
  MCBSignY: string,
  MCBDegree: string,
  MCBDegreeX: string,
  MCBDegreeY: string,
  MCBMinute: string,
  MCBMinuteX: string,
  MCBMinuteY: string,
  PlBSym:string,
  PlBPlanetX: string,
  PlBPlanetY: string,
  PlBSign: string,
  PlBSignSym: string,
  PlBSignX: string,
  PlBSignY: string,
  PlBDegree: string,
  PlBDegreeX: string,
  PlBDegreeY: string,
  PlBMinute: string,
  PlBMinuteX: string,
  PlBMinuteY: string,
  PlBRX: boolean,
  PlBRXX: string,
  PlBRXY: string,
  MaBSym:string,
  MaBPlanetX: string,
  MaBPlanetY: string,
  MaBSign: string,
  MaBSignSym: string,
  MaBSignX: string,
  MaBSignY: string,
  MaBDegree: string,
  MaBDegreeX: string,
  MaBDegreeY: string,
  MaBMinute: string,
  MaBMinuteX: string,
  MaBMinuteY: string,
  MaBRX: boolean,
  MaBRXX: string,
  MaBRXY: string,
  SaBSym:string,
  SaBPlanetX: string,
  SaBPlanetY: string,
  SaBSign: string,
  SaBSignSym: string,
  SaBSignX: string,
  SaBSignY: string,
  SaBDegree: string,
  SaBDegreeX: string,
  SaBDegreeY: string,
  SaBMinute: string,
  SaBMinuteX: string,
  SaBMinuteY: string,
  SaBRX: boolean,
  SaBRXX: string,
  SaBRXY: string,
  NeBSym:string,
  NeBPlanetX: string,
  NeBPlanetY: string,
  NeBSign: string,
  NeBSignSym: string,
  NeBSignX: string,
  NeBSignY: string,
  NeBDegree: string,
  NeBDegreeX: string,
  NeBDegreeY: string,
  NeBMinute: string,
  NeBMinuteX: string,
  NeBMinuteY: string,
  NeBRX: boolean,
  NeBRXX: string,
  NeBRXY: string,
  LoFoBSym:string,
  LoFoBPlanetX: string,
  LoFoBPlanetY: string,
  LoFoBSign: string,
  LoFoBSignSym: string,
  LoFoBSignX: string,
  LoFoBSignY: string,
  LoFoBDegree: string,
  LoFoBDegreeX: string,
  LoFoBDegreeY: string,
  LoFoBMinute: string,
  LoFoBMinuteX: string,
  LoFoBMinuteY: string

}

export const ChartBSvg = ({
  className = '',
  centerX = '475',
  centerY = '475',
  signRadius = '525',
  signBorderRadius = '526',
  planetRadius = '400',
  houseRadius = '300',
  centerRadius = '50',
  DegreeSym = '°',
  AriBSignX = '-46',
  AriBSignY = '614',
  TauBSignX = '93',
  TauBSignY = '856',
  GemBSignX = '335',
  GemBSignY = '996',
  CanBSignX = '614',
  CanBSignY = '996',
  LeoBSignX = '856',
  LeoBSignY = '856',
  VirBSignX = '996',
  VirBSignY = '614',
  LibBSignX = '996',
  LibBSignY = '335',
  ScoBSignX = '856',
  ScoBSignY = '93',
  SagBSignX = '614',
  SagBSignY = '-46',
  CapBSignX = '335',
  CapBSignY = '-46',
  AquBSignX = '93',
  AquBSignY = '93',
  PisBSignX = '-46',
  PisBSignY = '335',
  RXBSym = 'M',
  MoBPlanetX = '25',
  MoBPlanetY = '503',
  MoBSym = 'R',
  MoBSign = 'Ari',
  MoBSignSym = 'A',
  MoBSignX = '110',
  MoBSignY = '497',
  MoBDegree = '1',
  MoBDegreeX = '75',
  MoBDegreeY = '500',
  MoBMinute = '22',
  MoBMinuteX = '140',
  MoBMinuteY = '495',
  VeBPlanetX = '29',
  VeBPlanetY = '536',
  VeBSym = 'T',
  VeBSign = 'Ari',
  VeBSignSym = 'A',
  VeBSignX = '113',
  VeBSignY = '525',
  VeBDegree = '2',
  VeBDegreeX = '78',
  VeBDegreeY = '529',
  VeBMinute = '58',
  VeBMinuteX = '143',
  VeBMinuteY = '520',
  VeBRX = false,
  VeBRXX = '0',
  VeBRXY = '0',
  ASCBSym= 'a',
  ASCBPlanetX = '35',
  ASCBPlanetY = '570',
  ASCBSign = 'Ari',
  ASCBSignSym = 'A',
  ASCBSignX = '118',
  ASCBSignY = '552',
  ASCBDegree = '14',
  ASCBDegreeX = '84',
  ASCBDegreeY = '559',
  ASCBMinute = '47',
  ASCBMinuteX = '147',
  ASCBMinuteY = '545',
  RaBSym = '<',
  RaBPlanetX = '43',
  RaBPlanetY = '602',
  RaBSign = 'Ari',
  RaBSignSym = 'A',
  RaBSignX = '125',
  RaBSignY = '578',
  RaBDegree = '15',
  RaBDegreeX = '91',
  RaBDegreeY = '588',
  RaBMinute = '38',
  RaBMinuteX = '153',
  RaBMinuteY = '570',
  RaBRX = true,
  RaBRXX = '0',
  RaBRXY = '0',
  SuBSym = 'Q',
  SuBPlanetX = '54',
  SuBPlanetY = '634',
  SuBSign = 'Ari',
  SuBSignSym = 'A',
  SuBSignX = '133',
  SuBSignY = '604',
  SuBDegree = '18',
  SuBDegreeX = '101',
  SuBDegreeY = '617',
  SuBMinute = '13',
  SuBMinuteX = '161',
  SuBMinuteY = '593',
  ChBSym = 't',
  ChBPlanetX = '67',
  ChBPlanetY = '665',
  ChBSign = 'Ari',
  ChBSignSym = 'A',
  ChBSignX = '144',
  ChBSignY = '629',
  ChBDegree = '19',
  ChBDegreeX = '112',
  ChBDegreeY = '644',
  ChBMinute = '20',
  ChBMinuteX = '171',
  ChBMinuteY = '617',
  ChBRX = false,
  ChBRXX = '0',
  ChBRXY = '0',
  MeBSym = 'S',
  MeBPlanetX = '82',
  MeBPlanetY = '695',
  MeBSign = 'Ari',
  MeBSignSym = 'A',
  MeBSignX = '157',
  MeBSignY = '654',
  MeBDegree = '25',
  MeBDegreeX = '126',
  MeBDegreeY = '671',
  MeBMinute = '31',
  MeBMinuteX = '183',
  MeBMinuteY = '639',
  MeBRX = true,
  MeBRXX = '209',
  MeBRXY = '624',
  JuBSym = 'V',
  JuBPlanetX = '165',
  JuBPlanetY = '802',
  JuBSign = 'Tau',
  JuBSignSym = 'B',
  JuBSignX = '224',
  JuBSignY = '740',
  JuBDegree = '18',
  JuBDegreeX = '200',
  JuBDegreeY = '765',
  JuBMinute = '47',
  JuBMinuteX = '244',
  JuBMinuteY = '718',
  JuBRX = false,
  JuBRXX = '0',
  JuBRXY = '0',
  UrBSym = 'X',
  UrBPlanetX = '200',
  UrBPlanetY = '831',
  UrBSign = 'Tau',
  UrBSignSym = 'B',
  UrBSignX = '252',
  UrBSignY = '763',
  UrBDegree = '21',
  UrBDegreeX = '230',
  UrBDegreeY = '791',
  UrBMinute = '7',
  UrBMinuteX = '270',
  UrBMinuteY = '740',
  UrBRX = false,
  UrBRXX = '0',
  UrBRXY = '0',
  ICBSym= 'c',
  ICBPlanetX = '539',
  ICBPlanetY = '920',
  ICBSign = 'Can',
  ICBSignSym = 'D',
  ICBSignX = '527',
  ICBSignY = '836',
  ICBDegree = '7',
  ICBDegreeX = '532',
  ICBDegreeY = '870',
  ICBMinute = '1',
  ICBMinuteX = '523',
  ICBMinuteY = '806',
  DSCBSym = 'DC',
  DSCBPlanetX = '916',
  DSCBPlanetY = '385',
  DSCBSign = 'Lib',
  DSCBSignSym = 'G',
  DSCBSignX = '832',
  DSCBSignY = '402',
  DSCBDegree = '14',
  DSCBDegreeX = '867',
  DSCBDegreeY = '395',
  DSCBMinute = '47',
  DSCBMinuteX = '803',
  DSCBMinuteY = '408',
  KeBSym = '>',
  KeBPlanetX = '908',
  KeBPlanetY = '352',
  KeBSign = 'Lib',
  KeBSignSym = 'G',
  KeBSignX = '826',
  KeBSignY = '375',
  KeBDegree = '15',
  KeBDegreeX = '859',
  KeBDegreeY = '366',
  KeBMinute = '38',
  KeBMinuteX = '797',
  KeBMinuteY = '383',
  KeBRX = true,
  KeBRXX = '0',
  KeBRXY = '0',
  MCBSym = 'b',
  MCBPlanetX = '416',
  MCBPlanetY = '28',
  MCBSign = 'Cap',
  MCBSignSym = 'J',
  MCBSignX = '427',
  MCBSignY = '113',
  MCBDegree = '7',
  MCBDegreeX = '422',
  MCBDegreeY = '78',
  MCBMinute = '1',
  MCBMinuteX = '431',
  MCBMinuteY = '142',
  PlBSym = 'Z',
  PlBPlanetX = '227',
  PlBPlanetY = '99',
  PlBSign = 'Aqu',
  PlBSignSym = 'K',
  PlBSignX = '274',
  PlBSignY = '170',
  PlBDegree = '1',
  PlBDegreeX = '255',
  PlBDegreeY = '140',
  PlBMinute = '57',
  PlBMinuteX = '290',
  PlBMinuteY = '195',
  PlBRX = false,
  PlBRXX = '0',
  PlBRXY = '0',
  MaBSym = 'U',
  MaBPlanetX = '46',
  MaBPlanetY = '336',
  MaBSign = 'Pis',
  MaBSignSym = 'L',
  MaBSignX = '127',
  MaBSignY = '362',
  MaBDegree = '12',
  MaBDegreeX = '94',
  MaBDegreeY = '351',
  MaBMinute = '7',
  MaBMinuteX = '156',
  MaBMinuteY = '371',
  MaBRX = false,
  MaBRXX = '0',
  MaBRXY = '0',
  SaBSym = 'W',
  SaBPlanetX = '37',
  SaBPlanetY = '368',
  SaBSign = 'Pis',
  SaBSignSym = 'L',
  SaBSignX = '120',
  SaBSignY = '389',
  SaBDegree = '14',
  SaBDegreeX = '86',
  SaBDegreeY = '380',
  SaBMinute = '20',
  SaBMinuteX = '149',
  SaBMinuteY = '396',
  SaBRX = false,
  SaBRXX = '0',
  SaBRXY = '0',
  NeBSym = 'Y',
  NeBPlanetX = '25',
  NeBPlanetY = '458',
  NeBSign = 'Pis',
  NeBSignSym = 'L',
  NeBSignX = '110',
  NeBSignY = '461',
  NeBDegree = '28',
  NeBDegreeX = '75',
  NeBDegreeY = '459',
  NeBMinute = '9',
  NeBMinuteX = '140',
  NeBMinuteY = '462',
  NeBRX = false,
  NeBRXX = '0',
  NeBRXY = '0',
  LoFoBSym = ';',
  LoFoBPlanetX = '71',
  LoFoBPlanetY = '841',
  LoFoBSign = 'Can',
  LoFoBSignSym = 'D',
  LoFoBSignX = '134',
  LoFoBSignY = '784',
  LoFoBDegree = '12',
  LoFoBDegreeX = '108',
  LoFoBDegreeY = '808',
  LoFoBMinute = '42',
  LoFoBMinuteX = '157',
  LoFoBMinuteY = '764'
 
}: Props
  ) => (
  //props: SVGProps<SVGSVGElement> 
  <svg viewBox="-120, -120, 1190, 1190" className={className}>
    {/* {...props}  */}
    <circle
      id="sign-ring"
      className="sign-ring"
      fill="currentColor"
      cx={centerX}
      cy={centerY}
      r={signRadius}
    />
    <g id="sign-ring" className="sign-ring__content">
    <text
        id="Ari-sign"
        fill="currentColor"
        x={AriBSignX}
        y={AriBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + AriBSignX + ',' + AriBSignY + ')'}
      >
        {"A"}
      </text>
      <text
        id="Tau-sign"
        fill="currentColor"
        x={TauBSignX}
        y={TauBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + TauBSignX + ',' + TauBSignY+ ')'}
      >
        {"B"}
      </text>
      <text
        id="Gem-sign"
        fill="currentColor"
        x={GemBSignX}
        y={GemBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + GemBSignX+ ',' + GemBSignY + ')'}
      >
        {"C"}
      </text>
      <text
        id="Can-sign"
        fill="currentColor"
        x={CanBSignX}
        y={CanBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + CanBSignX + ',' + CanBSignY + ')'}
        >
        {"D"}
      </text>
      <text
        id="Leo-sign"
        fill="currentColor"
        x={LeoBSignX}
        y={LeoBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + LeoBSignX + ',' + LeoBSignY + ')'}
        >
        {"E"}
        </text>
        <text
        id="Vir-sign"
        fill="currentColor"
        x={VirBSignX}
        y={VirBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + VirBSignX + ',' + VirBSignY + ')'}
        >
        {"F"}
        </text>
        <text
        id="Lib-sign"
        fill="currentColor"
        x={LibBSignX}
        y={LibBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + LibBSignX + ',' + LibBSignY + ')'}
        >
        {"G"}
        </text>
        <text
        id="Sco-sign"
        fill="currentColor"
        x={ScoBSignX}
        y={ScoBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + ScoBSignX + ',' + ScoBSignY + ')'}
        >
        {"H"}
        </text>
        <text
        id="Sag-sign"
        fill="currentColor"
        x={SagBSignX}
        y={SagBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + SagBSignX + ',' + SagBSignY + ')'}
        >
        {"I"}
      </text>
      <text
        id="Cap-sign"
        fill="currentColor"
        x={CapBSignX}
        y={CapBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + CapBSignX + ',' + CapBSignY + ')'}
        >
        {"J"}
      </text>
      <text
        id="Aqu-sign"
        fill="currentColor"
        x={AquBSignX}
        y={AquBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + AquBSignX + ',' + AquBSignY + ')'}
        >
        {"K"}
      </text>
      <text
        id="Pis-sign"
        fill="currentColor"
        x={PisBSignX}
        y={PisBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        transform={'rotate(0,' + PisBSignX + ',' + PisBSignY + ')'}
        >
        {"L"}
      </text>
    </g>
    <circle
      id="planet-ring"
      className="planet-ring"
      fill="currentColor"
      cx={centerX}
      cy={centerY}
      r={planetRadius}
    />
  

  <g id="axes" className="axes">
    <path id="1-axis" className="1-axis" d="M372 475 L-100 475 Z" />
    <path id="2-axis" className="2-axis" d="M386 526 L-22 762 Z" />
    <path id="3-axis" className="3-axis" d="M423 563 L187 972 Z" />
    <path id="4-axis" className="4-axis" d="M475 577 L475 1050 Z" />
    <path id="5-axis" className="5-axis" d="M526 563 L762 972 Z" />
    <path id="6-axis" className="6-axis" d="M563 526 L972 762 Z" />
    <path id="7-axis" className="7-axis" d="M577 475 L1050 475 Z" />
    <path id="8-axis" className="8-axis" d="M563 423 L972 187 Z" />
    <path id="9-axis" className="9-axis" d="M526 386 L762 -22 Z" />
    <path id="10-axis" className="10-axis" d="M475 372 L475 -100 Z" />
    <path id="11-axis" className="11-axis" d="M423 386 L187 -22 Z" />
    <path id="12-axis" className="12-axis" d="M386 423 L-22 187 Z" />
  </g>

  <circle
    id="house-ring"
    className="house-ring"
    fill="currentColor"
    cx={centerX}
    cy={centerY}
    r={houseRadius}
    />
    <circle
    id="center-ring"
    className="center-ring"
    fill="currentColor"
    cx={centerX}
    cy={centerY}
    r={centerRadius}
    />


    {/* <g id="axes" className="axes">
      <path id="1-axis" className="1-axis" d="M365 475 L0 475 Z" />
      <path id="2-axis" className="2-axis" d="M379 530 L63 712 Z" />
      <path id="3-axis" className="3-axis" d="M420 570 L237 886 Z" />
      <path id="4-axis" className="4-axis" d="M475 585 L475 950 Z" />
      <path id="5-axis" className="5-axis" d="M530 570 L712 886 Z" />
      <path id="6-axis" className="6-axis" d="M570 530 L886 712 Z" />
      <path id="7-axis" className="7-axis" d="M585 475 L950 475 Z" />
      <path id="8-axis" className="8-axis" d="M570 420 L886 237 Z" />
      <path id="9-axis" className="9-axis" d="M530 379 L712 63 Z" />
      <path id="10-axis" className="10-axis" d="M475 365 L475 0 Z" />
      <path id="11-axis" className="11-axis" d="M420 379 L237 63 Z" />
      <path id="12-axis" className="12-axis" d="M379 420 L63 237 Z" />
    </g> */}


<g id="axes" className="house-axes">
  <path id="1-axis" className="1-axis" d="M420 475 L270 475 Z" />
  <path id="2-axis" className="2-axis" d="M427 502 L297 577 Z" />
  <path id="3-axis" className="3-axis" d="M447 522 L372 652 Z" />
  <path id="4-axis" className="4-axis" d="M475 530 L475 680 Z" />
  <path id="5-axis" className="5-axis" d="M502 522 L577 652 Z" />
  <path id="6-axis" className="6-axis" d="M522 502 L652 577 Z" />
  <path id="7-axis" className="7-axis" d="M530 475 L680 475 Z" />
  <path id="8-axis" className="8-axis" d="M522 447 L652 372 Z" />
  <path id="9-axis" className="9-axis" d="M502 427 L577 297 Z" />
  <path id="10-axis" className="10-axis" d="M475 420 L475 270 Z" />
  <path id="11-axis" className="11-axis" d="M447 427 L372 297 Z" />
  <path id="12-axis" className="12-axis" d="M427 447 L297 372 Z" />
</g>
    {/* <g id="starburst" className="starburst">
      <path
        id="2-bisect-axis"
        className="bisect-axis"
        transform="rotate(2.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="4-bisect-axis"
        className="bisect-axis"
        transform="rotate(4.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="6-bisect-axis"
        className="bisect-axis"
        transform="rotate(6.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="8-bisect-axis"
        className="bisect-axis"
        transform="rotate(8.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="10-bisect-axis"
        className="bisect-axis"
        transform="rotate(10.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="12-bisect-axis"
        className="bisect-axis"
        transform="rotate(12.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="14-bisect-axis"
        className="bisect-axis"
        transform="rotate(14.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="16-bisect-axis"
        className="bisect-axis"
        transform="rotate(16.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="18-bisect-axis"
        className="bisect-axis"
        transform="rotate(18.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="20-bisect-axis"
        className="bisect-axis"
        transform="rotate(20.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="22-bisect-axis"
        className="bisect-axis"
        transform="rotate(22.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="24-bisect-axis"
        className="bisect-axis"
        transform="rotate(24.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="26-bisect-axis"
        className="bisect-axis"
        transform="rotate(26.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="28-bisect-axis"
        className="bisect-axis"
        transform="rotate(28.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="30-bisect-axis"
        className="bisect-axis"
        transform="rotate(30.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="32-bisect-axis"
        className="bisect-axis"
        transform="rotate(32.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="34-bisect-axis"
        className="bisect-axis"
        transform="rotate(34.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="36-bisect-axis"
        className="bisect-axis"
        transform="rotate(36.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="38-bisect-axis"
        className="bisect-axis"
        transform="rotate(38.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="40-bisect-axis"
        className="bisect-axis"
        transform="rotate(40.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="42-bisect-axis"
        className="bisect-axis"
        transform="rotate(42.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="44-bisect-axis"
        className="bisect-axis"
        transform="rotate(44.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="46-bisect-axis"
        className="bisect-axis"
        transform="rotate(46.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="48-bisect-axis"
        className="bisect-axis"
        transform="rotate(48.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="50-bisect-axis"
        className="bisect-axis"
        transform="rotate(50.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="52-bisect-axis"
        className="bisect-axis"
        transform="rotate(52.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="54-bisect-axis"
        className="bisect-axis"
        transform="rotate(54.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="56-bisect-axis"
        className="bisect-axis"
        transform="rotate(56.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="58-bisect-axis"
        className="bisect-axis"
        transform="rotate(58.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="60-bisect-axis"
        className="bisect-axis"
        transform="rotate(60.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="62-bisect-axis"
        className="bisect-axis"
        transform="rotate(62.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="64-bisect-axis"
        className="bisect-axis"
        transform="rotate(64.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="66-bisect-axis"
        className="bisect-axis"
        transform="rotate(66.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="68-bisect-axis"
        className="bisect-axis"
        transform="rotate(68.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="70-bisect-axis"
        className="bisect-axis"
        transform="rotate(70.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="72-bisect-axis"
        className="bisect-axis"
        transform="rotate(72.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="74-bisect-axis"
        className="bisect-axis"
        transform="rotate(74.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="76-bisect-axis"
        className="bisect-axis"
        transform="rotate(76.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="78-bisect-axis"
        className="bisect-axis"
        transform="rotate(78.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="80-bisect-axis"
        className="bisect-axis"
        transform="rotate(80.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="82-bisect-axis"
        className="bisect-axis"
        transform="rotate(82.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="84-bisect-axis"
        className="bisect-axis"
        transform="rotate(84.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="86-bisect-axis"
        className="bisect-axis"
        transform="rotate(86.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="88-bisect-axis"
        className="bisect-axis"
        transform="rotate(88.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="90-bisect-axis"
        className="bisect-axis"
        transform="rotate(90.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="92-bisect-axis"
        className="bisect-axis"
        transform="rotate(92.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="94-bisect-axis"
        className="bisect-axis"
        transform="rotate(94.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="96-bisect-axis"
        className="bisect-axis"
        transform="rotate(96.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="98-bisect-axis"
        className="bisect-axis"
        transform="rotate(98.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="100-bisect-axis"
        className="bisect-axis"
        transform="rotate(100.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="102-bisect-axis"
        className="bisect-axis"
        transform="rotate(102.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="104-bisect-axis"
        className="bisect-axis"
        transform="rotate(104.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="106-bisect-axis"
        className="bisect-axis"
        transform="rotate(106.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="108-bisect-axis"
        className="bisect-axis"
        transform="rotate(108.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="110-bisect-axis"
        className="bisect-axis"
        transform="rotate(110.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="112-bisect-axis"
        className="bisect-axis"
        transform="rotate(112.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="114-bisect-axis"
        className="bisect-axis"
        transform="rotate(114.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="116-bisect-axis"
        className="bisect-axis"
        transform="rotate(116.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="118-bisect-axis"
        className="bisect-axis"
        transform="rotate(118.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="120-bisect-axis"
        className="bisect-axis"
        transform="rotate(120.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="122-bisect-axis"
        className="bisect-axis"
        transform="rotate(122.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="124-bisect-axis"
        className="bisect-axis"
        transform="rotate(124.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="126-bisect-axis"
        className="bisect-axis"
        transform="rotate(126.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="128-bisect-axis"
        className="bisect-axis"
        transform="rotate(128.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="130-bisect-axis"
        className="bisect-axis"
        transform="rotate(130.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="132-bisect-axis"
        className="bisect-axis"
        transform="rotate(132.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="134-bisect-axis"
        className="bisect-axis"
        transform="rotate(134.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="136-bisect-axis"
        className="bisect-axis"
        transform="rotate(136.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="138-bisect-axis"
        className="bisect-axis"
        transform="rotate(138.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="140-bisect-axis"
        className="bisect-axis"
        transform="rotate(140.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="142-bisect-axis"
        className="bisect-axis"
        transform="rotate(142.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="144-bisect-axis"
        className="bisect-axis"
        transform="rotate(144.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="146-bisect-axis"
        className="bisect-axis"
        transform="rotate(146.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="148-bisect-axis"
        className="bisect-axis"
        transform="rotate(148.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="150-bisect-axis"
        className="bisect-axis"
        transform="rotate(150.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="152-bisect-axis"
        className="bisect-axis"
        transform="rotate(152.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="154-bisect-axis"
        className="bisect-axis"
        transform="rotate(154.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="156-bisect-axis"
        className="bisect-axis"
        transform="rotate(156.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="158-bisect-axis"
        className="bisect-axis"
        transform="rotate(158.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="160-bisect-axis"
        className="bisect-axis"
        transform="rotate(160.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="162-bisect-axis"
        className="bisect-axis"
        transform="rotate(162.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="164-bisect-axis"
        className="bisect-axis"
        transform="rotate(164.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="166-bisect-axis"
        className="bisect-axis"
        transform="rotate(166.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="168-bisect-axis"
        className="bisect-axis"
        transform="rotate(168.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="170-bisect-axis"
        className="bisect-axis"
        transform="rotate(170.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="172-bisect-axis"
        className="bisect-axis"
        transform="rotate(172.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="174-bisect-axis"
        className="bisect-axis"
        transform="rotate(174.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="176-bisect-axis"
        className="bisect-axis"
        transform="rotate(176.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="178-bisect-axis"
        className="bisect-axis"
        transform="rotate(178.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="180-bisect-axis"
        className="bisect-axis"
        transform="rotate(180.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="182-bisect-axis"
        className="bisect-axis"
        transform="rotate(182.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="184-bisect-axis"
        className="bisect-axis"
        transform="rotate(184.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="186-bisect-axis"
        className="bisect-axis"
        transform="rotate(186.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="188-bisect-axis"
        className="bisect-axis"
        transform="rotate(188.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="190-bisect-axis"
        className="bisect-axis"
        transform="rotate(190.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="192-bisect-axis"
        className="bisect-axis"
        transform="rotate(192.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="194-bisect-axis"
        className="bisect-axis"
        transform="rotate(194.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="196-bisect-axis"
        className="bisect-axis"
        transform="rotate(196.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="198-bisect-axis"
        className="bisect-axis"
        transform="rotate(198.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="200-bisect-axis"
        className="bisect-axis"
        transform="rotate(200.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="202-bisect-axis"
        className="bisect-axis"
        transform="rotate(202.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="204-bisect-axis"
        className="bisect-axis"
        transform="rotate(204.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="206-bisect-axis"
        className="bisect-axis"
        transform="rotate(206.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="208-bisect-axis"
        className="bisect-axis"
        transform="rotate(208.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="210-bisect-axis"
        className="bisect-axis"
        transform="rotate(210.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="212-bisect-axis"
        className="bisect-axis"
        transform="rotate(212.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="214-bisect-axis"
        className="bisect-axis"
        transform="rotate(214.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="216-bisect-axis"
        className="bisect-axis"
        transform="rotate(216.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="218-bisect-axis"
        className="bisect-axis"
        transform="rotate(218.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="220-bisect-axis"
        className="bisect-axis"
        transform="rotate(220.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="222-bisect-axis"
        className="bisect-axis"
        transform="rotate(222.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="224-bisect-axis"
        className="bisect-axis"
        transform="rotate(224.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="226-bisect-axis"
        className="bisect-axis"
        transform="rotate(226.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="228-bisect-axis"
        className="bisect-axis"
        transform="rotate(228.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="230-bisect-axis"
        className="bisect-axis"
        transform="rotate(230.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="232-bisect-axis"
        className="bisect-axis"
        transform="rotate(232.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="234-bisect-axis"
        className="bisect-axis"
        transform="rotate(234.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="236-bisect-axis"
        className="bisect-axis"
        transform="rotate(236.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="238-bisect-axis"
        className="bisect-axis"
        transform="rotate(238.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="240-bisect-axis"
        className="bisect-axis"
        transform="rotate(240.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="242-bisect-axis"
        className="bisect-axis"
        transform="rotate(242.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="244-bisect-axis"
        className="bisect-axis"
        transform="rotate(244.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="246-bisect-axis"
        className="bisect-axis"
        transform="rotate(246.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="248-bisect-axis"
        className="bisect-axis"
        transform="rotate(248.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="250-bisect-axis"
        className="bisect-axis"
        transform="rotate(250.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="252-bisect-axis"
        className="bisect-axis"
        transform="rotate(252.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="254-bisect-axis"
        className="bisect-axis"
        transform="rotate(254.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="256-bisect-axis"
        className="bisect-axis"
        transform="rotate(256.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="258-bisect-axis"
        className="bisect-axis"
        transform="rotate(258.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="260-bisect-axis"
        className="bisect-axis"
        transform="rotate(260.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="262-bisect-axis"
        className="bisect-axis"
        transform="rotate(262.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="264-bisect-axis"
        className="bisect-axis"
        transform="rotate(264.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="266-bisect-axis"
        className="bisect-axis"
        transform="rotate(266.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="268-bisect-axis"
        className="bisect-axis"
        transform="rotate(268.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="270-bisect-axis"
        className="bisect-axis"
        transform="rotate(270.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="272-bisect-axis"
        className="bisect-axis"
        transform="rotate(272.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="274-bisect-axis"
        className="bisect-axis"
        transform="rotate(274.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="276-bisect-axis"
        className="bisect-axis"
        transform="rotate(276.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="278-bisect-axis"
        className="bisect-axis"
        transform="rotate(278.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="280-bisect-axis"
        className="bisect-axis"
        transform="rotate(280.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="282-bisect-axis"
        className="bisect-axis"
        transform="rotate(282.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="284-bisect-axis"
        className="bisect-axis"
        transform="rotate(284.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="286-bisect-axis"
        className="bisect-axis"
        transform="rotate(286.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="288-bisect-axis"
        className="bisect-axis"
        transform="rotate(288.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="290-bisect-axis"
        className="bisect-axis"
        transform="rotate(290.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="292-bisect-axis"
        className="bisect-axis"
        transform="rotate(292.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="294-bisect-axis"
        className="bisect-axis"
        transform="rotate(294.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="296-bisect-axis"
        className="bisect-axis"
        transform="rotate(296.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="298-bisect-axis"
        className="bisect-axis"
        transform="rotate(298.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="300-bisect-axis"
        className="bisect-axis"
        transform="rotate(300.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="302-bisect-axis"
        className="bisect-axis"
        transform="rotate(302.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="304-bisect-axis"
        className="bisect-axis"
        transform="rotate(304.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="306-bisect-axis"
        className="bisect-axis"
        transform="rotate(306.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="308-bisect-axis"
        className="bisect-axis"
        transform="rotate(308.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="310-bisect-axis"
        className="bisect-axis"
        transform="rotate(310.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="312-bisect-axis"
        className="bisect-axis"
        transform="rotate(312.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="314-bisect-axis"
        className="bisect-axis"
        transform="rotate(314.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="316-bisect-axis"
        className="bisect-axis"
        transform="rotate(316.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="318-bisect-axis"
        className="bisect-axis"
        transform="rotate(318.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="320-bisect-axis"
        className="bisect-axis"
        transform="rotate(320.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="322-bisect-axis"
        className="bisect-axis"
        transform="rotate(322.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="324-bisect-axis"
        className="bisect-axis"
        transform="rotate(324.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="326-bisect-axis"
        className="bisect-axis"
        transform="rotate(326.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="328-bisect-axis"
        className="bisect-axis"
        transform="rotate(328.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="330-bisect-axis"
        className="bisect-axis"
        transform="rotate(330.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="332-bisect-axis"
        className="bisect-axis"
        transform="rotate(332.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="334-bisect-axis"
        className="bisect-axis"
        transform="rotate(334.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="336-bisect-axis"
        className="bisect-axis"
        transform="rotate(336.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="338-bisect-axis"
        className="bisect-axis"
        transform="rotate(338.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="340-bisect-axis"
        className="bisect-axis"
        transform="rotate(340.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="342-bisect-axis"
        className="bisect-axis"
        transform="rotate(342.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="344-bisect-axis"
        className="bisect-axis"
        transform="rotate(344.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="346-bisect-axis"
        className="bisect-axis"
        transform="rotate(346.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="348-bisect-axis"
        className="bisect-axis"
        transform="rotate(348.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="350-bisect-axis"
        className="bisect-axis"
        transform="rotate(350.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="352-bisect-axis"
        className="bisect-axis"
        transform="rotate(352.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="354-bisect-axis"
        className="bisect-axis"
        transform="rotate(354.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="356-bisect-axis"
        className="bisect-axis"
        transform="rotate(356.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="358-bisect-axis"
        className="bisect-axis"
        transform="rotate(358.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="360-bisect-axis"
        className="bisect-axis"
        transform="rotate(360.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="362-bisect-axis"
        className="bisect-axis"
        transform="rotate(362.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="364-bisect-axis"
        className="bisect-axis"
        transform="rotate(364.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="366-bisect-axis"
        className="bisect-axis"
        transform="rotate(366.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="368-bisect-axis"
        className="bisect-axis"
        transform="rotate(368.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="370-bisect-axis"
        className="bisect-axis"
        transform="rotate(370.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="372-bisect-axis"
        className="bisect-axis"
        transform="rotate(372.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="374-bisect-axis"
        className="bisect-axis"
        transform="rotate(374.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="376-bisect-axis"
        className="bisect-axis"
        transform="rotate(376.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="378-bisect-axis"
        className="bisect-axis"
        transform="rotate(378.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="380-bisect-axis"
        className="bisect-axis"
        transform="rotate(380.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="382-bisect-axis"
        className="bisect-axis"
        transform="rotate(382.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
      <path
        id="384-bisect-axis"
        className="bisect-axis"
        transform="rotate(384.5, 475,475)"
        d="M475 475 L335 475  Z"
      />
    </g> */}
  
    {/* <g id="house-numbers" className="house-ring__content">
      <text
        id="house-1"
        fill="currentColor"
        x={359}
        y={506}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,359,506)"
      >
        {"1"}
      </text>
      <text
        id="house-2"
        fill="currentColor"
        x={390}
        y={559}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,390,559)"
      >
        {"2"}
      </text>
      <text
        id="house-3"
        fill="currentColor"
        x={443}
        y={590}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,443,590)"
      >
        {"3"}
      </text>
      <text
        id="house-4"
        fill="currentColor"
        x={506}
        y={590}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,506,590)"
      >
        {"4"}
      </text>
      <text
        id="house-5"
        fill="currentColor"
        x={559}
        y={559}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,559,559)"
      >
        {"5"}
      </text>
      <text
        id="house-6"
        fill="currentColor"
        x={590}
        y={506}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,590,506)"
      >
        {"6"}
      </text>
      <text
        id="house-7"
        fill="currentColor"
        x={590}
        y={443}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,590,443)"
      >
        {"7"}
      </text>
      <text
        id="house-8"
        fill="currentColor"
        x={559}
        y={390}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,559,390)"
      >
        {"8"}
      </text>
      <text
        id="house-9"
        fill="currentColor"
        x={506}
        y={359}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,506,359)"
      >
        {"9"}
      </text>
      <text
        id="house-10"
        fill="currentColor"
        x={443}
        y={359}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,443,359)"
      >
        {"10"}
      </text>
      <text
        id="house-11"
        fill="currentColor"
        x={390}
        y={390}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,390,390)"
      >
        {"11"}
      </text>
      <text
        id="house-12"
        fill="currentColor"
        x={359}
        y={443}
        textAnchor="middle"
        dominantBaseline="central"
        transform="rotate(0,359,443)"
      >
        {"12"}
      </text>
    </g> */}
  <g id="house numbers" className="house-ring__content">
  <text id="house-1"
    fill="currentColor"
    x="320"
    y="516"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,312,518)"
  >
    {"1"}
  </text>
  <text id="house-2"
    fill="currentColor"
    x="361"
    y="588"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,356,593)"
  >
    {"2"}
  </text>
  <text id="house-3"
    fill="currentColor"
    x="433"
    y="629"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,431,637)"
  >
    {"3"}
  </text>
  <text id="house-4"
    fill="currentColor"
    x="516"
    y="629"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,518,637)"
  >
    {"4"}
  </text>
  <text id="house-5"
    fill="currentColor"
    x="588"
    y="588"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,593,593)"
  >
    {"5"}
  </text>
  <text id="house-6"
    fill="currentColor"
    x="629"
    y="516"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,637,518)"
  >
    {"6"}
  </text>
  <text id="house-7"
    fill="currentColor"
    x="629"
    y="433"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,637,431)"
  >
    {"7"}
  </text>
  <text id="house-8"
    fill="currentColor"
    x="588"
    y="361"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,593,356)"
  >
    {"8"}
  </text>
  <text id="house-9"
    fill="currentColor"
    x="516"
    y="320"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,518,312)"
  >
    {"9"}
  </text>
  <text id="house-10"
    fill="currentColor"
    x="433"
    y="320"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,431,312)"
  >
    {"10"}
  </text>
  <text id="house-11"
    fill="currentColor"
    x="361"
    y="361"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,356,356)"
  >
    {"11"}
  </text>
  <text id="house-12"
    fill="currentColor"
    x="320"
    y="431"
    textAnchor="middle"
    dominantBaseline="central"
    transform="rotate(0,312,431)"
  >
    {"12"}
  </text>
</g>

<g className="planet-ring__content">
<g id="Mo-p-group">
<text
        id="Mo-planet"
        className="Mo planet-ring__planet"
        fill="currentColor"
        x={MoBPlanetX}
        y={MoBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MoPlanetX==null ? '0' : MoPlanetX + ',' + MoPlanetY==null ? '0' : MoPlanetY + ')'}
        >
        {MoBSym}
</text>
<text
        id="Mo-sign"
        className={MoBSign + " planet-ring__sign"}
        fill="currentColor"
        x={MoBSignX}
        y={MoBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MoSignX==null ? '0' : MoSignX + ',' + MoSignY==null ? '0' : MoSignY + ')'}
        >
        {MoBSignSym}
</text>
<text
        id="Mo-degree"
        fill="currentColor"
        x={MoBDegreeX}
        y={MoBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MoDegreeX + ',' + MoDegreeY + ')'}
        >
        {MoBDegree}{MoBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Mo-minute"
        fill="currentColor"
        x={MoBMinuteX}
        y={MoBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MoMinuteX + ',' + MoMinuteY + ')'}
        >
        {MoBMinute}
</text>
</g>
<g id="Ve-p-group">
<text
        id="Ve-planet"
        className="Ve planet-ring__planet"
        fill="currentColor"
        x={VeBPlanetX}
        y={VeBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + VePlanetX + ',' + VePlanetY + ')'}
        >
        {VeBSym}
</text>
<text
        id="Ve-sign"
        className={VeBSign + " planet-ring__sign"}
        fill="currentColor"
        x={VeBSignX}
        y={VeBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + VeSignX + ',' + VeSignY + ')'}
        >
        {VeBSignSym}
</text>
<text
        id="Ve-degree"
        className={VeBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={VeBDegreeX}
        y={VeBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + VeDegreeX + ',' + VeDegreeY + ')'}
        >
        {VeBDegree}{VeBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ve-minute"
        className={VeBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={VeBMinuteX}
        y={VeBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + VeMinuteX + ',' + VeMinuteY + ')'}
        >
        {VeBMinute}
</text>
        {VeBRX === false ? null: <text
        id="Ve-rx"
        className="Ve planet-ring__planet rx"
        fill="currentColor"
        x={VeBRXX}
        y={VeBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + VeRXX + ',' + VeRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="ASC-p-group">
<text
        id="ASC-planet"
        className="ASC planet-ring__planet"
        fill="currentColor"
        x={ASCBPlanetX}
        y={ASCBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ASCPlanetX + ',' + ASCPlanetY + ')'}
        >
        {ASCBSym}
</text>
<text
        id="ASC-sign"
        className={ASCBSign + " planet-ring__sign"}
        fill="currentColor"
        x={ASCBSignX}
        y={ASCBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ASCSignX + ',' + ASCSignY + ')'}
        >
        {ASCBSignSym}
</text>
<text
        id="ASC-degree"
        fill="currentColor"
        x={ASCBDegreeX}
        y={ASCBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ASCDegreeX + ',' + ASCDegreeY + ')'}
        >
        {ASCBDegree}{ASCBDegree == '' ? null : DegreeSym}
</text>
<text
        id="ASC-minute"
        fill="currentColor"
        x={ASCBMinuteX}
        y={ASCBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ASCMinuteX + ',' + ASCMinuteY + ')'}
        >
        {ASCBMinute}
</text>
</g>
<g id="Ra-p-group">
<text
        id="Ra-planet"
        className="Ra planet-ring__planet"
        fill="currentColor"
        x={RaBPlanetX}
        y={RaBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + RaPlanetX + ',' + RaPlanetY + ')'}
        >
        {RaBSym}
</text>
<text
        id="Ra-sign"
        className={RaBSign + " planet-ring__sign"}
        fill="currentColor"
        x={RaBSignX}
        y={RaBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + RaSignX + ',' + RaSignY + ')'}
        >
        {RaBSignSym}
</text>
<text
        id="Ra-degree"
        className={RaBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={RaBDegreeX}
        y={RaBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + RaDegreeX + ',' + RaDegreeY + ')'}
        >
        {RaBDegree}{RaBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ra-minute"
        className={RaBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={RaBMinuteX}
        y={RaBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + RaMinuteX + ',' + RaMinuteY + ')'}
        >
        {RaBMinute}
</text>
        {RaBRX === false ? null: <text
        id="Ra-rx"
        className="Ra planet-ring__planet rx"
        fill="currentColor"
        x={RaBRXX}
        y={RaBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + RaRXX + ',' + RaRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="Su-p-group">
<text
        id="Su-planet"
        className="Su planet-ring__planet"
        fill="currentColor"
        x={SuBPlanetX}
        y={SuBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SuPlanetX + ',' + SuPlanetY + ')'}
        >
        {SuBSym}
</text>
<text
        id="Su-sign"
        className={SuBSign + " planet-ring__sign"}
        fill="currentColor"
        x={SuBSignX}
        y={SuBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SuSignX + ',' + SuSignY + ')'}
        >
        {SuBSignSym}
</text>
<text
        id="Su-degree"
        fill="currentColor"
        x={SuBDegreeX}
        y={SuBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SuDegreeX + ',' + SuDegreeY + ')'}
        >
        {SuBDegree}{SuBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Su-minute"
        fill="currentColor"
        x={SuBMinuteX}
        y={SuBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SuMinuteX + ',' + SuMinuteY + ')'}
        >
        {SuBMinute}
</text>
</g>
<g id="Ch-p-group">
<text
        id="Ch-planet"
        className="Ch planet-ring__planet"
        fill="currentColor"
        x={ChBPlanetX}
        y={ChBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ChPlanetX + ',' + ChPlanetY + ')'}
        >
        {ChBSym}
</text>
<text
        id="Ch-sign"
        className={ChBSign + " planet-ring__sign"}
        fill="currentColor"
        x={ChBSignX}
        y={ChBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ChSignX + ',' + ChSignY + ')'}
        >
        {ChBSignSym}
</text>
<text
        id="Ch-degree"
        className={ChBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={ChBDegreeX}
        y={ChBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ChDegreeX + ',' + ChDegreeY + ')'}
        >
        {ChBDegree}{ChBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ch-minute"
        className={ChBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={ChBMinuteX}
        y={ChBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ChMinuteX + ',' + ChMinuteY + ')'}
        >
        {ChBMinute}
</text>
        {ChBRX === false ? null : <text
        id="Ch-rx"
        className="Ch planet-ring__planet rx"
        fill="currentColor"
        x={ChBRXX}
        y={ChBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ChRXX + ',' + ChRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="Me-p-group">
<text
        id="Me-planet"
        className="Me planet-ring__planet"
        fill="currentColor"
        x={MeBPlanetX}
        y={MeBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MePlanetX + ',' + MePlanetY + ')'}
        >
        {MeBSym}
</text>
<text
        id="Me-sign"
        className={MeBSign + " planet-ring__sign"}
        fill="currentColor"
        x={MeBSignX}
        y={MeBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MeSignX + ',' + MeSignY + ')'}
        >
        {MeBSignSym}
</text>
<text
        id="Me-degree"
        className={MeBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={MeBDegreeX}
        y={MeBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MeDegreeX + ',' + MeDegreeY + ')'}
        >
        {MeBDegree}{MeBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Me-minute"
        className={MeBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={MeBMinuteX}
        y={MeBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MeMinuteX + ',' + MeMinuteY + ')'}
        >
        {MeBMinute}
</text>
        {MeBRX === false ? null : <text
        id="Me-rx"
        className="Me planet-ring__planet rx"
        fill="currentColor"
        x={MeBRXX}
        y={MeBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MeRXX + ',' + MeRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="Ju-p-group">
<text
        id="Ju-planet"
        className="Ju planet-ring__planet"
        fill="currentColor"
        x={JuBPlanetX}
        y={JuBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + JuPlanetX + ',' + JuPlanetY + ')'}
        >
        {JuBSym}
</text>
<text
        id="Ju-sign"
        className={JuBSign + " planet-ring__sign"}
        fill="currentColor"
        x={JuBSignX}
        y={JuBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + JuSignX + ',' + JuSignY + ')'}
        >
        {JuBSignSym}
</text>
<text
        id="Ju-degree"
        className={JuBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={JuBDegreeX}
        y={JuBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + JuDegreeX + ',' + JuDegreeY + ')'}
        >
        {JuBDegree}{JuBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ju-minute"
        className={JuBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={JuBMinuteX}
        y={JuBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + JuMinuteX + ',' + JuMinuteY + ')'}
        >
        {JuBMinute}
</text>
        {JuBRX === false ? null : <text
        id="Ju-rx"
        className="Ju planet-ring__planet rx"
        fill="currentColor"
        x={JuBRXX}
        y={JuBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + JuRXX + ',' + JuRXY + ')'}
        >
        {RXBSym}
</text>}
</g>

<g id="LoFo-p-group">
<text
        id="LoFo-planet"
        className="LoFo planet-ring__planet"
        fill="currentColor"
        x={LoFoBPlanetX}
        y={LoFoBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + LoFoPlanetX + ',' + LoFoPlanetY + ')'}
        >
        {LoFoBSym}
</text>
<text
        id="LoFo-sign"
        className={LoFoBSign + " planet-ring__sign"}
        fill="currentColor"
        x={LoFoBSignX}
        y={LoFoBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + LoFoSignX + ',' + LoFoSignY + ')'}
        >
        {LoFoBSignSym}
</text>
<text
        id="LoFo-degree"
        className="degree"
        fill="currentColor"
        x={LoFoBDegreeX}
        y={LoFoBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + LoFoDegreeX + ',' + LoFoDegreeY + ')'}
        >
        {LoFoBDegree}{LoFoBDegree == '' ? null : DegreeSym}
</text>
<text
        id="LoFo-minute"
        className="minute"
        fill="currentColor"
        x={LoFoBMinuteX}
        y={LoFoBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + LoFoMinuteX + ',' + LoFoMinuteY + ')'}
        >
        {LoFoBMinute}
</text>
</g>

<g id="Ur-p-group">
<text
        id="Ur-planet"
        className="Ur planet-ring__planet"
        fill="currentColor"
        x={UrBPlanetX}
        y={UrBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + UrPlanetX + ',' + UrPlanetY + ')'}
        >
        {UrBSym}
</text>
<text
        id="Ur-sign"
        className={UrBSign + " planet-ring__sign"}
        fill="currentColor"
        x={UrBSignX}
        y={UrBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + UrSignX + ',' + UrSignY + ')'}
        >
        {UrBSignSym}
</text>
<text
        id="Ur-degree"
        className={UrBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={UrBDegreeX}
        y={UrBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + UrDegreeX + ',' + UrDegreeY + ')'}
        >
        {UrBDegree}{UrBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ur-minute"
        className={UrBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={UrBMinuteX}
        y={UrBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + UrMinuteX + ',' + UrMinuteY + ')'}
        >
        {UrBMinute}
</text>
        {UrBRX === false ? null : <text
        id="Ur-rx"
        className="Ur planet-ring__planet rx"
        fill="currentColor"
        x={UrBRXX}
        y={UrBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + UrRXX + ',' + UrRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="IC-p-group">
<text
        id="IC-planet"
        className="IC planet-ring__planet"
        fill="currentColor"
        x={ICBPlanetX}
        y={ICBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ICPlanetX + ',' + ICPlanetY + ')'}
        >
        {ICBSym}
</text>
<text
        id="IC-sign"
        className={ICBSign + " planet-ring__sign"}
        fill="currentColor"
        x={ICBSignX}
        y={ICBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ICSignX + ',' + ICSignY + ')'}
        >
        {ICBSignSym}
</text>
<text
        id="IC-degree"
        fill="currentColor"
        x={ICBDegreeX}
        y={ICBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ICDegreeX + ',' + ICDegreeY + ')'}
        >
        {ICBDegree}{ICBDegree == '' ? null : DegreeSym}
</text>
<text
        id="IC-minute"
        fill="currentColor"
        x={ICBMinuteX}
        y={ICBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + ICMinuteX + ',' + ICMinuteY + ')'}
        >
        {ICBMinute}
</text>
</g>
<g id="DSC-p-group">
<text
        id="DSC-planet"
        className="DSC planet-ring__planet"
        fill="currentColor"
        x={DSCBPlanetX}
        y={DSCBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + DSCPlanetX + ',' + DSCPlanetY + ')'}
        >
        {DSCBSym}
</text>
<text
        id="DSC-sign"
        className={DSCBSign + " planet-ring__sign"}
        fill="currentColor"
        x={DSCBSignX}
        y={DSCBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + DSCSignX + ',' + DSCSignY + ')'}
        >
        {DSCBSignSym}
</text>
<text
        id="DSC-degree"
        fill="currentColor"
        x={DSCBDegreeX}
        y={DSCBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + DSCDegreeX + ',' + DSCDegreeY + ')'}
        >
        {DSCBDegree}{DSCBDegree == '' ? null : DegreeSym}
</text>
<text
        id="DSC-minute"
        fill="currentColor"
        x={DSCBMinuteX}
        y={DSCBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + DSCMinuteX + ',' + DSCMinuteY + ')'}
        >
        {DSCBMinute}
</text>
</g>
<g id="Ke-p-group">
<text
        id="Ke-planet"
        className="Ke planet-ring__planet"
        fill="currentColor"
        x={KeBPlanetX}
        y={KeBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + KePlanetX + ',' + KePlanetY + ')'}
        >
        {KeBSym}
</text>
<text
        id="Ke-sign"
        className={KeBSign + " planet-ring__sign"}
        fill="currentColor"
        x={KeBSignX}
        y={KeBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + KeSignX + ',' + KeSignY + ')'}
        >
        {KeBSignSym}
</text>
<text
        id="Ke-degree"
        className={KeBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={KeBDegreeX}
        y={KeBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + KeDegreeX + ',' + KeDegreeY + ')'}
        >
        {KeBDegree}{KeBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ke-minute"
        className={KeBRX === true ? "Ke minute rx" : "Ke minute"}
        fill="currentColor"
        x={KeBMinuteX}
        y={KeBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + KeMinuteX + ',' + KeMinuteY + ')'}
        >
        {KeBMinute}
</text>
        {KeBRX === false ? null : <text
        id="Ke-rx"
        className="Ke planet-ring__planet rx"
        fill="currentColor"
        x={KeBRXX}
        y={KeBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + KeRXX + ',' + KeRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="MC-p-group">
<text
        id="MC-planet"
        className="MC planet-ring__planet"
        fill="currentColor"
        x={MCBPlanetX}
        y={MCBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MCPlanetX + ',' + MCPlanetY + ')'}
        >
        {MCBSym}
</text>
<text
        id="MC-sign"
        className={MCBSign + " planet-ring__sign"}
        fill="currentColor"
        x={MCBSignX}
        y={MCBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MCSignX + ',' + MCSignY + ')'}
        >
        {MCBSignSym}
</text>
<text
        id="MC-degree"
        fill="currentColor"
        x={MCBDegreeX}
        y={MCBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MCDegreeX + ',' + MCDegreeY + ')'}
        >
        {MCBDegree}{MCBDegree == '' ? null : DegreeSym}
</text>
<text
        id="MC-minute"
        fill="currentColor"
        x={MCBMinuteX}
        y={MCBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MCMinuteX + ',' + MCMinuteY + ')'}
        >
        {MCBMinute}
</text>
</g>
<g id="Pl-p-group">
<text
        id="Pl-planet"
        className="Pl planet-ring__planet"
        fill="currentColor"
        x={PlBPlanetX}
        y={PlBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + PlPlanetX + ',' + PlPlanetY + ')'}
        >
        {PlBSym}
</text>
<text
        id="Pl-sign"
        className={PlBSign + " planet-ring__sign"}
        fill="currentColor"
        x={PlBSignX}
        y={PlBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + PlSignX + ',' + PlSignY + ')'}
        >
        {PlBSignSym}
</text>
<text
        id="Pl-degree"
        className={PlBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={PlBDegreeX}
        y={PlBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + PlDegreeX + ',' + PlDegreeY + ')'}
        >
        {PlBDegree}{PlBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Pl-minute"
        className={PlBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={PlBMinuteX}
        y={PlBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + PlMinuteX + ',' + PlMinuteY + ')'}
        >
        {PlBMinute}
</text>
        {PlBRX === false ? null : <text
        id="Pl-rx"
        className="Pl planet-ring__planet rx"
        fill="currentColor"
        x={PlBRXX}
        y={PlBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + PlRXX + ',' + PlRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="Ma-p-group">
<text
        id="Ma-planet"
        className="Ma planet-ring__planet"
        fill="currentColor"
        x={MaBPlanetX}
        y={MaBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MaPlanetX + ',' + MaPlanetY + ')'}
        >
        {MaBSym}
</text>
<text
        id="Ma-sign"
        className={MaBSign + " planet-ring__sign"}
        fill="currentColor"
        x={MaBSignX}
        y={MaBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MaSignX + ',' + MaSignY + ')'}
        >
        {MaBSignSym}
</text>
<text
        id="Ma-degree"
        className={MaBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={MaBDegreeX}
        y={MaBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MaDegreeX + ',' + MaDegreeY + ')'}
        >
        {MaBDegree}{MaBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ma-minute"
        className={MaBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={MaBMinuteX}
        y={MaBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MaMinuteX + ',' + MaMinuteY + ')'}
        >
        {MaBMinute}
</text>
        {MaBRX === false ? null : <text
        id="Ma-rx"
        className="Ma planet-ring__planet rx"
        fill="currentColor"
        x={MaBRXX}
        y={MaBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + MaRXX + ',' + MaRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="Sa-p-group">
<text
        id="Sa-planet"
        className="Sa planet-ring__planet"
        fill="currentColor"
        x={SaBPlanetX}
        y={SaBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SaPlanetX + ',' + SaPlanetY + ')'}
        >
        {SaBSym}
</text>
<text
        id="Sa-sign"
        className={SaBSign + " planet-ring__sign"}
        fill="currentColor"
        x={SaBSignX}
        y={SaBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SaSignX + ',' + SaSignY + ')'}
        >
        {SaBSignSym}
</text>
<text
        id="Sa-degree"
        className={SaBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={SaBDegreeX}
        y={SaBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SaDegreeX + ',' + SaDegreeY + ')'}
        >
        {SaBDegree}{SaBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Sa-minute"
        className={SaBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={SaBMinuteX}
        y={SaBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SaMinuteX + ',' + SaMinuteY + ')'}
        >
        {SaBMinute}
</text>
        {SaBRX === false ? null : <text
        id="Sa-rx"
        className="Sa planet-ring__planet rx"
        fill="currentColor"
        x={SaBRXX}
        y={SaBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + SaRXX + ',' + SaRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
<g id="Ne-p-group">
<text
        id="Ne-planet"
        className="Ne planet-ring__planet"
        fill="currentColor"
        x={NeBPlanetX}
        y={NeBPlanetY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + NePlanetX + ',' + NePlanetY + ')'}
        >
        {NeBSym}
</text>
<text
        id="Ne-sign"
        className={NeBSign + " planet-ring__sign"}
        fill="currentColor"
        x={NeBSignX}
        y={NeBSignY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + NeSignX + ',' + NeSignY + ')'}
        >
        {NeBSignSym}
</text>
<text
        id="Ne-degree"
        className={NeBRX === true ? "degree rx" : "degree"}
        fill="currentColor"
        x={NeBDegreeX}
        y={NeBDegreeY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + NeDegreeX + ',' + NeDegreeY + ')'}
        >
        {NeBDegree}{NeBDegree == '' ? null : DegreeSym}
</text>
<text
        id="Ne-minute"
        className={NeBRX === true ? "minute rx" : "minute"}
        fill="currentColor"
        x={NeBMinuteX}
        y={NeBMinuteY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + NeMinuteX + ',' + NeMinuteY + ')'}
        >
        {NeBMinute}
</text>
        {NeBRX === false ? null : <text
        id="Ne-rx"
        className="Ne planet-ring__planet rx"
        fill="currentColor"
        x={NeBRXX}
        y={NeBRXY}
        textAnchor="middle"
        dominantBaseline="central"
        // transform={'rotate(0,' + NeRXX + ',' + NeRXY + ')'}
        >
        {RXBSym}
</text>}
</g>
</g>

<g>
    <path
      transform="translate(-22,-22) scale(1.02 1.02)"
      d="M432.83,393.14c-16.51,9.68-30.26,23.54-39.82,40.13L0,205.74C49.75,120.84,120.67,49.85,205.5,0l227.33,393.14h0Z"
      className="hover-house" id="house-11" 
    />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M862.75,77.54l-232.73,403.23c-16.03-9.16-34.59-14.39-54.37-14.41l.83-465h.07c104.2,0,201.92,27.72,286.2,76.18Z"
    className="hover-house" id="house-9"
      />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M575.05.86v465.16c-1.01-.04-2.03-.05-3.04-.05-19.37,0-37.57,5.03-53.45,13.89L288.05,76.86C372.78,28.48,470.71.86,575.05.86Z"
    className="hover-house" id="house-10"
      />
  </g>
  <g>
  <path 
    transform="translate(-102,-100)"
    d="M684.61,574.09c.04-1.04.05-2.07.05-3.11,0-17.84-4.19-34.69-11.66-49.6l400.45-230.87c48.06,83.81,75.83,180.87,76.55,284.39l-465.39-.8Z"
    className="hover-house" id="house-7"
    /> 
  </g>
  <g>
  <path
    transform="translate(-100,-100)" 
    d="M1072.7,287.29l-402.31,233.32s-.02-.03-.03-.05c-9.73-16.52-23.66-30.26-40.32-39.78l232.68-402.68c86.91,50.2,159.47,122.48,209.98,209.19Z"
    className="hover-house" id="house-8"
    />
  </g>

  <g>
  <path 
    transform="translate(-100,-100)"
    d="M1151.55,576.36c0,104.83-28.05,203.1-77.07,287.73l-403.58-232.84c9.32-16.16,14.65-34.9,14.65-54.89h466Z"
    className="hover-house" id="house-6"
    />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M630.75,671.17c16.9-9.92,30.97-24.12,40.76-41.12l402.24,233.16c-50.92,87-123.51,159.75-210.33,210.84l-232.67-402.88h0Z"
    className="hover-house" id="house-5"
    />
  </g>
  <g>
  <path 
    transform="translate(-100,-100)"
    d="M575.32,1149.8v-465.16c1.01.04,2.03.05,3.04.05,19.37,0,37.57-5.03,53.45-13.89l230.51,403c-84.73,48.38-182.66,76-287,76Z"
    className="hover-house" id="house-4"
    />
    </g>
    <g>
  <path 
    transform="translate(-100,-100)"
    d="M288.22,1073.37l232.73-403.23c16.03,9.16,34.59,14.39,54.37,14.41l-.83,465h-.07c-104.2,0-201.92-27.72-286.2-76.18h0Z"
    className="hover-house" id="house-3"
    />
    </g>
    <g>
    <path 
    transform="translate(-100,-100)"
    d="M77.76,863.89l402.31-233.32s.02.03.03.05c9.73,16.52,23.66,30.26,40.32,39.78l-232.68,402.68c-86.91-50.2-159.47-122.48-209.98-209.19Z"
    className="hover-house" id="house-2"
    />
    </g>
    <g>
    <path 
    transform="translate(-100,-100)"
    d="M466.87,576.09c-.04,1.05-.04,2.1-.04,3.15.06,18.07,4.32,35.12,11.85,50.19l-400.5,235.14C29.74,779.86,1.58,681.67.51,576.84l466.36-.76h0Z"
    className="hover-house" id="house-1"
    />
    </g>
    <g>
    <path 
    transform="translate(-100,-100)"
    d="M.5,574.55c0-104.83,28.05-203.1,77.07-287.73l403.58,232.84c-9.32,16.16-14.65,34.9-14.65,54.89H.5s0,0,0,0Z"
    className="hover-house" id="house-12"
    />
    </g>
    {/* <circle 
      className="hover-chart-border"
      cx={centerX}
      cy={centerY}
      r={signBorderRadius}
      fill="currentColor"
      /> */}

   
  </svg>
)
export { ChartBSvg as ReactComponent }
